import React from 'react'
import { useSelector } from 'react-redux'
import {
  STORES,
  APP_STORE_LINK,
  PLAY_STORE_LINK,
  BRAND_DISPLAY_NAME,
  PRIVACY_POLICY_URL,
  TERMS_OF_USAGE,
  INFORMATION_SECURITY,
  CONTRACTS_AND_REGULATIONS_URL,
} from 'app-constants'
import { STATICS } from 'statics'
import './style.scss'

export function Footer() {
  const selectedContract = useSelector(({ contract }) => contract.selected)

  function handleOpenApp(store) {
    const link = store === STORES.APPLE ? APP_STORE_LINK : PLAY_STORE_LINK

    window.open(link)
  }

  function renderAppleStoreBadge() {
    if (!APP_STORE_LINK) return null

    return (
      <button type='button' onClick={() => handleOpenApp(STORES.APPLE)} className='link'>
        <STATICS.APPLE_BADGE alt='Logo App Store' className='icon' />
      </button>
    )
  }

  function renderGooglePlayBadge() {
    if (!PLAY_STORE_LINK) return null

    return (
      <button type='button' onClick={() => handleOpenApp(STORES.ANDROID)} className='link'>
        <STATICS.GOOGLE_BADGE alt='Logo Google Play Store' className='icon' />
      </button>
    )
  }

  function renderFooter() {
    return (
      <footer className='footer-component'>
        <div className='content-wrapper'>
          <div className='footer-body'>
            <div className='logo-and-store'>
              <img className='logo' src={STATICS.LOGO} alt={`${BRAND_DISPLAY_NAME} logo`} />
              <p className='store-description'>Baixe o aplicativo {BRAND_DISPLAY_NAME}</p>
              <div className='store-buttons'>
                {renderAppleStoreBadge()}
                {renderGooglePlayBadge()}
              </div>
            </div>
            <div className='footer-navigation'>
              <a href={TERMS_OF_USAGE} className='link' target='_blank' rel='noreferrer'>
                Termos de uso
              </a>
              <a href={INFORMATION_SECURITY} className='link' target='_blank' rel='noreferrer'>
                Segurança da informação
              </a>
              <a href={PRIVACY_POLICY_URL} className='link' target='_blank' rel='noreferrer'>
                Política de Privacidade
              </a>
              <a
                href={CONTRACTS_AND_REGULATIONS_URL}
                className='link'
                target='_blank'
                rel='noreferrer'
              >
                Contratos
              </a>
            </div>
          </div>
          <div className='footer-bottom'>
            <div className='icon'>
              <STATICS.SHIELD_LOCK />
            </div>
            <p className='info-text'>
              Você está em um ambiente seguro. {new Date().getFullYear()} {BRAND_DISPLAY_NAME}.
              Todos os direitos reservados.
            </p>
          </div>
        </div>
      </footer>
    )
  }

  return !!selectedContract && renderFooter()
}
